import styles from './styles.module.css';

export default function DescriptionSaTool({ dict }) {
        const {
        description_sa_tool_1,
        description_sa_tool_2,
        description_sa_tool_3,
        description_sa_tool_4,
        description_sa_tool_5,
        description_sa_tool_6,
        description_sa_tool_7,
        description_sa_tool_8,
        description_sa_tool_9
    } = dict.discover;

    return (
        <div>
            <div>{description_sa_tool_1}</div>

            <ol className={styles.description_sa_tool__list}>
                <li>{description_sa_tool_2}</li>
                <li>{description_sa_tool_3}</li>
                <li>{description_sa_tool_4}</li>
                <li>{description_sa_tool_5}</li>
                <li>{description_sa_tool_6}</li>
                <li>{description_sa_tool_7}</li>
                <li>{description_sa_tool_8}</li>
            </ol>
            <p>{description_sa_tool_9}</p>
        </div>
    );
}
